import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Factuurregel } from '../dto/factuurregel';
import { CrudService, Filter } from '@mango/core';
import { FactoryTarget } from '@angular/compiler';

@Injectable({ providedIn: 'root' })
export class FactuurregelService extends CrudService<Factuurregel> {

    constructor(injector: Injector) { super(Factuurregel, injector); }

    getArtikelFilter(factuurId: number, pakbonregelId: number): Filter<Factuurregel> {
        return new Filter<Factuurregel>(fb => [fb.equal(x => x.factuur.id, factuurId), fb.equal(x => x.pakbonregel.id, pakbonregelId), fb.notEqual(x => x.artikel.id, null)]);
    }

}
